// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1yqFX","header":"MergedInvoice_header__3a37X"};